// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1555":"2d67394d","7333":"72a146cc","8688":"9923b5b2","8861":"639c3fb6"}[chunkId] + ".chunk.css";
};